<template>
<div>
  <v-form
    class="pa-6"
    ref="form"
    v-model="valid"
    lazy-validation>

    <h3 class="text-left mb-1 text-primary">Initialize</h3>
    <p class="text-caption mb-4">Configurá las URLs y el access token.</p>
    <div class="d-flex ga-2 mb-6">
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="createInstance()">
        Create Instance >>
      </v-btn>
      <v-btn
          size="small"
          :disabled="!valid"
          color="primary"
          @click="initialize">
        Initialize >>
      </v-btn>
    </div>
    <v-row>
      <v-col md="6">
        <v-text-field
          v-model="urls"
          label="URLs"
        ></v-text-field>
        <v-text-field
          v-model="accessToken"
          label="Access Token"
          @change="updateRequest"
          :rules="[v => !!v || 'You must enter the access token']"
          required
          clearable
        ></v-text-field>
        <v-text-field
          v-model="timeout"
          label="Timeout"
          :rules="[v => !!v || 'You must enter the timeout']"
          required
          clearable
        ></v-text-field>
      </v-col>
      <v-col md="6">
        <v-textarea
            name="parameters"
            label="Parameters"
            no-resize
            height="400px"
            v-model="requestPayload"
        ></v-textarea>
      </v-col>
    </v-row>

    <v-divider class="my-6"></v-divider>

    <v-row>
      <v-col cols="12">
        <v-textarea
            name="response"
            label="Response"
            auto-grow
            v-model="response"
        ></v-textarea>
      </v-col>
    </v-row>

  </v-form>
</div>
</template>
<script>

import { mapMutations } from 'vuex'
  import alisonJS from  '@/services/alison_js.js'
  export default  {
    data: () => ({
      valid:false,
      urls: "[\"https://127.0.0.1:8004\",\"https://localhost:8004\",\"https://127.0.0.1:8005\"]",
      timeout: 10000,
      accessToken: '',
      requestPayload: "",
      result: "",
      response: "",
    }),
    mounted(){
      this.valid = false;
      this.accessToken = 'eyJ2ZXJzaW9uIjo0LCJ2MSI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6IjMvK0RKMmsxQS9yWjQxL0hlWllYS00ydG1XazE4cDM4RXg0WDdWTWZlYXhpS3dWUHZVRTZzaUh1aHplZThHU1RMR2FwUWRXaFJRNzlyQXRqeWpRWkYxeC83Rm1ZcERzVExnTTQzdDRlV2dMV2NaclQ2Sy9uRGwvc1ltRGtLZjBjWDFtc3JHbkM4RWNQNk9KQW04RGlhUG5ZVlR0ZUpaOVEzbVNJeDk2OGU0cnpJNlF6YUh2L09FQnVmUHhMbTdpMjhQS3JBbHdSS3BQZTFVc3c4eG45NjMxRlJWc1JxaEk1WGFoamRoV2RWQnRkRmg1bE51Y1BUUDVEbFQzdkJIZy94VmV5TllOdVcvRWFobUZiS2RSRS9IRmdEOFN0cnVPTTVvNXJLSHptc2xPbnJFSi8yQkdEa1AxcnF3Nm0wZnlZUTR6K2RpYzdlTHhLWnRsNUNGWGhBR0dLOEdIYXVJVGU5RWUrQUJjN3c1WC8zZkJKVDI4VTgyOEo1V0dOZ0t6TVo5akdsbzVLNVgxOEh1cHVvZ1BGSm9nVjkyV2llbmR5c2JXMmRiZXltcVNINDBTN2kvcDdLb2pRZ2ZyNWtveHl1ZFV1cmgvK1NuYXhYOEczMTF2THU0OUNIalpmdCtycXkvRFlUZFdRS3pYYTFHanZMME5zQkIyNTFRU01OdDdoLzFSYjJkdnNMVk5HcnNKR3BjNFhMWEx1a0J6V1pXSW4zeWd1cDZUMlR0SnhzZCtPSWhtVkxhZldNbHhNME03diJ9LCJ2MiI6eyJpZHgiOiI5LUxpY2Vuc2UiLCJ2YWx1ZSI6ImV5SmhiR2NpT2lKU1V6STFOaUo5LmV5SnBZWFFpT2pFM05EUXpNVEkyTURVc0ltVjRjQ0k2TVRnME56Y3pOakF3TUN3aVkyOXRjR0Z1ZVU1aGJXVWlPaUpEWlhKMGFWTjFjaUJUTGtFdUlpd2lZV3hzYjNkbFpFOXlhV2RwYm5NaU9sc2lLaTVqWlhKMGFYTjFjaTVqYjIwaUxDSXFMbU5sY25ScGMzVnlMbTVsZENJc0lpb3VZMlZ5ZEdsemRYSXVhVzVtYnlJc0lpb3VkbVZ5YVhOMWNpSXNJaW91ZEc5d2RISjFjM1F1WTI5dExtRnlJaXdpS2k1elpXTjFjbVZrYjJNdWJHRWlMQ0pqYUhKdmJXVXRaWGgwWlc1emFXOXVPaTh2YTNCcWJHRm5aR3B3WVdscGJXNWxZMlJpWkdOdVpHcGphV3B2WVd4aWJHRWlMQ0l4TWpjdU1DNHdMakU2T0RBd015SXNJakV5Tnk0d0xqQXVNVG80TURBMElpd2liRzlqWVd4b2IzTjBPamd3TURNaUxDSnNiMk5oYkdodmMzUTZPREF3TkNJc0lteHZZMkZzYUc5emRDNWpaWEowYVhOMWNpNXVaWFE2T0RBNE1DSmRmUS5Gc09hel9LRWJ2WFh1dkZldXVCWExNYU42dVNjcXF2akt2Vl94dnhrUjQ2eGxuMDZyWnhTby14NElHdjcxajN0dHpERWVXUkQzUTZyV1lfeTViajR3LS0wN1dGRnM4eE8zdVpDUVdfclh3enk5TTJ2bkxIRGdtc0IyNUFPYkhTUVY3QW9iNzRZYTJRcjdlMVFQZldGallpUjlMV3hlVGV0a2dpWTluV2U2MFRoNG5sZC1mbGJSbjVVVnExQ0hqTVBiR3llc0hmSktXSkxZN001NlRIN0pKTno2Q0FNTFIwQkRlSmpodUhJN2ktMkJ2MjRzMmREMFV4Q3ZXU1RJM1piODkyc2xQMVBFdHROWGpvU2tVWVotSlU0WU1GN2tSVDZabnZmR3ZYSjdPQXdnTTFvMFRjR0Q2NGt0bXVySk00dzJoVGZXUDd3SGxXNjFoNE1aamVRcmcifX0='
      this.updateRequest();
    },
    methods: {
      ...mapMutations({
        setSnack: 'setSnack',
        setColor: 'setColor'
      }),
      updateRequest(){
        this.requestPayload = JSON.stringify({ accessToken: this.accessToken}, null, "\t")
      },
      createInstance() {
        try{
          alisonJS.createInstance(JSON.parse(this.urls), this.timeout);
          this.setSnack("Alison Sdk Instance created")
          this.setColor('info')
        }catch(e) {
           this.setSnack("Alison Sdk Instance creation failed")
           this.setColor('error')
        }
      },
      initialize(){
          this.$emit('disableTab')
          alisonJS.initialize(JSON.parse(this.requestPayload)).then((res)=>{
            this.result = res;
            this.response = JSON.stringify(res, null, "\t");
            this.setColor('info')
            this.setSnack("Alison Sdk initialized")
            this.$emit('enableTab', ['Sign Desktop', 'Config Manager', 'Create Credential', 'Add second factors', 'Add certificate', 'List all Certificates', 'List enabled KeyStores', 'List available Profiles', 'Initialize Profile', 'Generate CSR', 'Generate Certificate', 'Install Certificate', 'Import Certificate'])
          }, (e) => {
            this.setColor('error')
            if(e.code && (e.detail || e.message)){
                if(e.message){ this.setSnack('ERROR ' + e.message) }
                else { this.setSnack('ERROR '+ e.code +': ' + e.detail) }
            }else{
              this.setSnack('FAILURE: ' + JSON.stringify(e))
            }
            this.result = e;
            this.response = JSON.stringify(e, null, "\t");
          })
      }
    },
  }
</script>
